export default __webpack_public_path__ + "static/Wheres_Mike_Teacher_Guide-f311619bf7a5d9896fd6b3e58d8925ff.pdf";